import * as Sentry from "@sentry/react";

// Auth uçlarını Sentry'ye loglama - hatalı şifre / OTP vb. gürültü oluşturmasın.
const isAuthEndpoint = (url) => {
  if (!url) return false;
  return url.includes("/auth/");
};

const prettyJson = (data) => {
  try {
    return typeof data === "string" ? data : JSON.stringify(data, null, 2);
  } catch {
    return "[unserializable]";
  }
};

// Tam URL'den host ve query string'i kırpıp kısa endpoint döndürür.
// Örn: http://10.68.216.54:4106/api/expense/delete?id=... -> expense/delete
const toShortEndpoint = (url) => {
  if (!url) return "";
  try {
    const path = url.startsWith("http")
      ? new URL(url).pathname
      : url.split("?")[0];
    return path.replace(/^\/?api\//, "").replace(/^\//, "");
  } catch {
    return url.split("?")[0];
  }
};

/**
 * Axios response (veya error.response) objesini alıp Sentry'ye API hata event'i gönderir.
 * medmasraf'ta axios `validateStatus: () => true` ile kurulduğu için 4xx/5xx yanıtlar
 * başarılı response olarak döner; bu yüzden logger response objesiyle çağrılır.
 */
export const logApiErrorToSentry = (response) => {
  const config = response?.config ?? {};
  const url = config.url;
  if (isAuthEndpoint(url)) return;

  const method = (config.method ?? "GET").toUpperCase();
  const body = config.data ?? null;
  const status = response?.status;
  const responseData = response?.data;
  const shortEndpoint = toShortEndpoint(url);
  const queryString = config.params
    ? new URLSearchParams(config.params).toString()
    : undefined;
  // Alt satırda gösterilecek tam URL (query dahil).
  const fullUrl =
    queryString && !url?.includes("?") ? `${url}?${queryString}` : url;

  Sentry.captureEvent({
    level: "error",
    // Aynı endpoint'in farklı parametreli istekleri tek issue altında gruplansın
    // (query string / id değiştikçe yeni issue açılmasın).
    fingerprint: [`HttpError${status}`, method, shortEndpoint],
    request: {
      url,
      method,
      data: body,
      query_string: queryString,
    },
    tags: {
      "api.endpoint": shortEndpoint,
      "api.method": method,
      "api.status": String(status),
    },
    exception: {
      values: [
        {
          // type -> issue başlığı (kategori), value -> alt satır (tam URL).
          type: `HttpError${status}`,
          value: `${method} ${fullUrl}`,
        },
      ],
    },
    breadcrumbs: [
      {
        timestamp: Date.now() / 1000,
        category: "api_request",
        level: "error",
        message: prettyJson(body),
        data: {
          url,
          method,
        },
      },
      {
        timestamp: Date.now() / 1000,
        category: "api_response",
        level: "error",
        message: prettyJson(responseData),
        data: {
          status,
        },
      },
    ],
  });
};
